<!-- ADD CASHOUT -->
<p-dialog
  class="filters-modal"
  header="Agregar transferencia interna"
  [modal]="true"
  [(visible)]="showNewTransactionType"
  [style]="{ width: '600px' }"
  *ngIf="showNewTransactionType"
  (visibleChange)="closeAddModal()"
>
  <div class="pick-title" *ngIf="showCurrency">
    Selecciona la moneda de la transferencia
  </div>
  <div class="form-item" *ngIf="showCurrency">
    <p-dropdown
      placeholder="Elige la moneda"
      [options]="allowedInternalTransferCurrencies"
      optionLabel="id"
      [(ngModel)]="currencyPicker"
      (onChange)="selectCurrency($event)"
    />
  </div>

  <div class="buttons-container">
    <p-button
      label="Cancelar"
      severity="danger"
      (click)="exitNewTransaction()"
    />
    <p-button
      label="Continuar"
      [disabled]="checkContinueDisabled()"
      severity="secondary"
      (click)="continue()"
    />
  </div>
</p-dialog>

<p-dialog
  class="filters-modal"
  header="Confirmar transferencia"
  [modal]="true"
  [(visible)]="showInternalConfirmation"
  [style]="{ width: '560px' }"
  *ngIf="showInternalConfirmation"
  (visibleChange)="backToInternalForm()"
>
  <div class="confirmation-screen">
    <div class="form-title">
      Confirma que los datos de tu transferencia estén correctos para continuar.
    </div>

    <div class="confirmation-details">
      <div
        class="confirmation-item"
        *ngFor="let detail of internalConfirmationDetails"
      >
        <span class="confirmation-label">{{ detail.label }}</span>
        <span class="confirmation-value">{{ detail.value }}</span>
      </div>
    </div>

    <div class="buttons-container">
      <p-button
        label="Volver"
        [outlined]="true"
        [disabled]="addingTransaction"
        (click)="backToInternalForm()"
      />
      <p-button
        label="Confirmar transferencia"
        severity="secondary"
        [loading]="addingTransaction"
        [disabled]="addingTransaction"
        (click)="confirmInternal()"
      />
    </div>
  </div>
</p-dialog>

<!-- ADD TRANSFER FORM -->
<p-dialog
  [maximizable]="true"
  class="filters-modal"
  header="Nueva transferencia interna"
  [modal]="true"
  [(visible)]="showNewTransaction"
  [style]="{ width: '600px' }"
  *ngIf="showNewTransaction"
  (visibleChange)="closeAddModal()"
>
  <div class="new-transaction-form">
    <div class="form-title">
      Ingresa los siguientes campos de tu transferencia
    </div>

    <div class="form-scroll-wrapper">
      <form class="form-container" [formGroup]="newTransactionForm">
        <div class="form-row">
          <div class="filter-column">
            <div class="form-item">
              <label for="status">Monto</label>
              <p-inputNumber
                formControlName="amount"
                [placeholder]="currencyPicker.shortname + ' 0,00'"
                [prefix]="currencyPicker.shortname + ' '"
                class="id-input-filter"
                mode="decimal"
                [minFractionDigits]="2"
                [maxFractionDigits]="8"
              />
            </div>

            <div class="form-item">
              <label for="status">Nombre de usuario receptor</label>
              <input
                placeholder="Ingresa el username del receptor"
                formControlName="destiny_user"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item" *ngIf="auth.hasRole(roles.Admin)">
              <label for="client_id">Cliente asignado</label>
              <p-dropdown
                placeholder="Elige un cliente"
                formControlName="client_id"
                [options]="userService.users"
                optionLabel="username"
                [filter]="true"
                filterBy="username"
              />
            </div>
            <div class="form-item" *ngIf="auth.hasRole(roles.Admin)">
              <label for="status">Modalidad de wallets</label>
              <div class="types-container">
                <div *ngFor="let type of transferTypes; let i = index">
                  <p-radioButton
                    [inputId]="type.value"
                    name="transfer_type"
                    [value]="type"
                    formControlName="transfer_type"
                  />
                  <label>
                    {{ type.label }}
                  </label>
                </div>
              </div>
              <div class="description">
                {{ getDescription() }}
              </div>

              <p-dropdown
                *ngIf="
                  newTransactionForm.controls.transfer_type.value!.value ===
                  'simple'
                "
                placeholder="Elige un wallet origen"
                formControlName="wallet_id"
                [options]="wallets"
                optionLabel="wallet_shortname"
                [filter]="true"
                filterBy="wallet_shortname"
              />

              <div
                class="description"
                *ngIf="
                  auth.hasRole(roles.Admin) &&
                  newTransactionForm.controls.transfer_type.value!.value ===
                    'simple'
                "
              >
                Para enviar entre wallets distintos entre el mismo usuario
                coloca el wallet destino acá:
              </div>

              <p-dropdown
                *ngIf="
                  auth.hasRole(roles.Admin) &&
                  newTransactionForm.controls.transfer_type.value!.value ===
                    'simple'
                "
                placeholder="Elige un wallet destino (Opcional)"
                formControlName="destiny_wallet_id"
                [options]="wallets"
                optionLabel="wallet_shortname"
                [filter]="true"
                filterBy="wallet_shortname"
              />
            </div>
            <div
              class="error-message"
              *ngIf="validSelector() && insufficientFunds()"
            >
              No tienes balance suficiente para realizar esta operación
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        (click)="exitNewTransaction()"
      />
      <p-button
        label="Guardar transferencia"
        [disabled]="
          newTransactionForm.invalid ||
          insufficientFunds() ||
          addingTransaction ||
          (newTransactionForm.controls.transfer_type.value!.value ===
            'simple' &&
            !newTransactionForm.controls.wallet_id.value)
        "
        [loading]="addingTransaction"
        severity="secondary"
        (click)="saveTransaction()"
      />
    </div>
  </div>
</p-dialog>
